import { render } from "./NewsletterConfigView.vue?vue&type=template&id=c2f81c16&scoped=true"
import script from "./NewsletterConfigView.vue?vue&type=script&lang=js"
export * from "./NewsletterConfigView.vue?vue&type=script&lang=js"

import "./NewsletterConfigView.vue?vue&type=style&index=0&id=c2f81c16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2f81c16"

export default script